axios.get(DoublyGlobal.ratesUrl)
.then(response =>{
	let DoublyCurrency
	if(response.status == 200){
		eval(response.data)

		store.state.currency.rates = Currency
	}

})

function setCookie(name,value,days) {
	var expires = "";
	if (days) {
			var date = new Date();
			date.setTime(date.getTime() + (days*24*60*60*1000));
			expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

setTimeout(() => {
	
	const optionsCurrency = document.querySelectorAll('.doubly-nice-select .option')
	optionsCurrency.forEach(x =>x.addEventListener("click", (event) => {
	
		let currency = event.target.getAttribute('data-value')


		store.state.currency.current = currency
		
		setCookie('currencyCookie',btoa(currency),null)
		setCookie(DoublyGlobal.cookieName,btoa(currency),null)
		setCookie('MXN',true,null)

	}))

	const optionsCountry = document.querySelectorAll('#country_code option')
	
	optionsCountry.forEach(x =>{
		x.innerHTML = x.innerHTML.split(' (')[0]

	})


	
}, 1000);

const CurrencyOptions = {
	store,
	name: 'CurrencyApp',
	delimiters: ['${', '}'],
	compilerOptions:{ 
			isCustomElement: tag => ['quantity-input', 'cart-remove-button'].includes(tag)
	},
	data() {

			return {
					currency: store.state.currency
			}

	},
	computed: {
			currentEspecialista(){
					if(!store.state.customer.address){

							return {}
					}
			}
	},
	created() {

	},
	methods:{

			
	}

}

const CurrencyApp = Vue.createApp(CurrencyOptions)


const initCurrencyApp = () => {
	CurrencyApp.mount('#CurrencyApp')
}

initCurrencyApp()
CurrencyApp.use(store)